import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import TextField from "@material-ui/core/TextField";

import { i18n } from "../../translate/i18n";
import AerosDialog from "../AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";

const FlowBuilderIntervalModal = ({ open, onSave, data, onUpdate, close }) => {
  const m = useAerosModalStyles();
  const [timerSec, setTimerSec] = useState(0);
  const [activeModal, setActiveModal] = useState(false);

  useEffect(() => {
    if (open === "edit") {
      setTimerSec(data.data.sec);
      setActiveModal(true);
    } else if (open === "create") {
      setTimerSec(0);
      setActiveModal(true);
    }
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = async () => {
    if (!timerSec || parseInt(timerSec) <= 0) {
      return toast.error(i18n.t("aeros.flow.modals.interval.errorEmpty"));
    }
    if (parseInt(timerSec) > 120) {
      return toast.error(i18n.t("aeros.flow.modals.interval.errorMax"));
    }
    if (open === "edit") {
      onUpdate({
        ...data,
        data: { sec: timerSec },
      });
    } else if (open === "create") {
      onSave({
        sec: timerSec,
      });
    }
    handleClose();
  };

  return (
    <AerosDialog
      open={activeModal}
      onClose={handleClose}
      width={480}
      title={i18n.t(open === "edit" ? "aeros.flow.modals.interval.editTitle" : "aeros.flow.modals.interval.addTitle")}
      onSubmit={handleSaveContact}
      submitLabel={i18n.t(open === "edit" ? "aeros.flow.save" : "aeros.flow.add")}
    >
      <div>
        <label className={m.fieldLabel} htmlFor="flow-interval-sec">
          {i18n.t("aeros.flow.modals.interval.seconds")}
        </label>
        <TextField
          id="flow-interval-sec"
          className={m.input}
          variant="outlined"
          name="timer"
          type="number"
          autoFocus
          value={timerSec}
          onChange={(e) => setTimerSec(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSaveContact()}
          InputProps={{ inputProps: { min: 0, max: 120 } }}
        />
        <div className={m.hint}>{i18n.t("aeros.flow.modals.interval.hint")}</div>
      </div>
    </AerosDialog>
  );
};

export default FlowBuilderIntervalModal;
